module.exports = __webpack_public_path__ + "img/active-courses.85a3bad4.svg";